import { API_URL } from "@/config/constants";
import axios from "axios";
import {
    IClauseSectionTypesResponse,
    IClauseSectionTypesUpdate,
} from "./clause-section-types.types";

const API = `${API_URL}/clauses`;

export const getClauseSectionTypes = async (
    clauseId: number
): Promise<IClauseSectionTypesResponse> => {
    const url = `${API}/${clauseId}/section-types`;
    const result = await axios.get<IClauseSectionTypesResponse>(url);
    return result.data;
};

export const updateClauseSectionTypes = async (
    clauseId: number,
    data: IClauseSectionTypesUpdate
): Promise<IClauseSectionTypesResponse> => {
    const url = `${API}/${clauseId}/section-types`;
    const result = await axios.put<IClauseSectionTypesResponse>(url, data);
    return result.data;
};
